import { colors, TableCell } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableCellStyled = styled(TableCell)`
  font-size: 1.4rem;
  line-height: 2rem;
  text-align: center;
  padding: 1.8rem 2.4rem;
  border: 0.05rem solid ${colors.neutral[300]};
  position: relative;

  &:not(:last-child) {
    border-right: 0;
  }
`;

export const MessageStyled = styled.span<{ $color: string }>`
  font-size: 1.2rem;
  font-weight: 500;
  position: absolute;
  top: 0;
  left: 0.5rem;
  color: ${({ $color }): string => $color};
`;

export const TableCellWithErrorStyled = styled(TableCellStyled)`
  position: relative;
  background-color: #ffc2c5;

  &::after {
    position: absolute;
    content: '';
    inset: 0;
    border: 2px solid ${colors.red[600]};
  }
`;

export const TableCellWithWarningStyled = styled(TableCellStyled)`
  position: relative;
  background-color: #ffdbc2;

  &::after {
    position: absolute;
    content: '';
    inset: 0;
    border: 2px solid ${colors.orange[700]};
  }
`;
